import { ButtonsFilterProps } from "./ButtonFilterInterface";
import { FilterButton } from "../buttons/FilterButton";
import { useAuth } from "../../context/AuthContext";
import { dictionary, Language } from "../../utils/dictionary";

export const ButtonsFilters = ({ filterOrders, activeFilter }: ButtonsFilterProps) => {
  const { language } = useAuth();
  return (
    <div className="flex space-x-2 p-4">
      <FilterButton 
        title={dictionary["all"][language]} 
        onClick={() => filterOrders("all")} 
        isActive={activeFilter === "all"} 
      />
      <FilterButton 
        title={dictionary["unfulfilled"][language]} 
        onClick={() => filterOrders("unfulfilled")} 
        isActive={activeFilter === "unfulfilled"} 
      />
      <FilterButton 
        title={dictionary["fulfilled"][language]} 
        onClick={() => filterOrders("fulfilled")} 
        isActive={activeFilter === "fulfilled"} 
      />
      <FilterButton 
        title={dictionary["paid"][language]} 
        onClick={() => filterOrders("paid")} 
        isActive={activeFilter === "paid"} 
      />
      <FilterButton 
        title={dictionary["pending"][language]} 
        onClick={() => filterOrders("pending")} 
        isActive={activeFilter === "pending"} 
      />
    </div>
  );
};
